// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__32Oo5","select":"Header_select__e1w1L","clinic":"Header_clinic__2LiBq"};